module.exports = __webpack_public_path__ + "img/pointimg.84ad2a05.png";